<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 登录 -->
      <div class="right">
        <p class="name">重置密码</p>
        <div class="error">{{ errorMsg }}</div>
        <el-form :model="resetForm" class="form">
          <el-form-item prop="passWord">
            <el-input
              v-model="resetForm.passWord"
              @input="changeStatus"
              prefix-icon="iconfont iconmima"
              placeholder="新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPassword">
            <el-input
              v-model="resetForm.checkPassword"
              @input="changeStatus"
              prefix-icon="iconfont iconmima"
              placeholder="再次输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :class="[!btnStatus ? 'btn-status' : '', 'login-btn']"
              type="primary"
              @click="btnStatus ? submitForm() : ''"
              >完成</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import leftImg from '@login/components/leftImg';
import { checkResetFormFormat } from '../../static/loginUtil';
import { mapActions } from 'vuex';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      resetForm: {
        passWord: '',
        checkPassword: '',
        userName: '',
      },
      errorMsg: '', //错误语提示
      btnStatus: false, //按钮可点击状态
    };
  },
  created() {
    console.log('created - 重置的账号: ', this.$route.params.userAccount);
    // 判断路由中是否带参 - 没有则重定向到“重置密码首页”
    this.handleCheckData();
  },
  methods: {
    ...mapActions('login', ['handleResetPwd']),

    // 校验路由参数
    handleCheckData() {
      if (!this.$route.params.userAccount) {
        this.$message({
          message: '重置密码数据异常',
          type: 'error',
          duration: 1500,
          onClose: () => {
            this.$router.replace({ name: 'forget' });
          },
        });
      } else {
        this.resetForm.userName = this.$route.params.userAccount;
      }
    },

    // 提交
    submitForm() {
      // 表单校验
      const formatRes = checkResetFormFormat(this);
      if (!formatRes) return;
      // 表单校验通过 => 发送请求
      this.submitResetPwd();
    },

    // 提交重置密码请求
    async submitResetPwd() {
      const { userName, passWord } = this.resetForm;
      await this.handleResetPwd({ userName, passWord });
      this.$message({
        message: '重置成功，请重新登录',
        type: 'success',
        duration: 1500,
        onClose: () => {
          this.$router.replace({
            path: '/login',
          });
        },
      });
    },
    // 输入密码
    changeStatus() {
      if (this.resetForm.passWord != '' && this.resetForm.checkPassword != '') {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  border-radius: 8px;
  margin: auto;
}
.right {
  width: 50%;
  height: 400px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
  }
  .error {
    color: #ff5f5f;
    font-size: 14px;
    min-height: 24px;
    padding: 0 60px 5px;
  }
  .form {
    max-width: 300px;
    margin: auto;
    .el-form-item {
      text-align: left;
      margin-bottom: 15px !important;
    }
  }
  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/.iconfont {
    font-size: 14px;
    color: #999;
  }
  /deep/.iconfont,
  .iconyonghu {
    font-size: 18px;
  }
  .login-btn {
    width: 300px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
    margin-top: 5px;
  }
  .btn-status {
    opacity: 0.4;
  }
  /deep/.el-form-item__error {
    top: -18px;
    left: 15px;
  }
}
</style>
